export class ObjectBuilder {
    constructor(builder) {
        this._rules = [];
        this.builder = builder;
    }
    ensure(property) {
        this._lastRule = undefined;
        return this.builder.ensure(property);
    }
    ensureSelf() {
        this._lastRule = undefined;
        return this.builder.ensureSelf();
    }
    if(condition) {
        return this.builder.if(condition);
    }
    satisfies(predicate) {
        const rule = { type: "self", predicate };
        this._rules.push(rule);
        this._lastRule = rule;
        return this;
    }
    isNotNull() {
        this.satisfies(value => value !== null && value !== undefined);
        return this;
    }
    isNull() {
        this.satisfies(value => value === null || value === undefined);
        return this;
    }
    withMessage(message) {
        const lastRule = this._lastRule;
        if (lastRule)
            lastRule.message = message;
        return this;
    }
    when(rule) {
        const lastRule = this._lastRule;
        if (lastRule)
            lastRule.condition = rule;
        return this;
    }
    rules() {
        return this.builder.rules();
    }
    build() {
        const validator = this.builder.build();
        return validator;
    }
}
